import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { locationCommandPermissions } from './command-permissions';

export interface ChangeAddressCommand {
  address: {
    addressLine1: string;
    addressLine2?: string;
    postalCode?: string;
    city: string;
    region?: string;
    country: string;
  };
}

const client = createClient('/rest/operator-api/pools');

export const changeAddress: SaveOperation<ChangeAddressCommand, void, string> = postRequestFactory<
  ChangeAddressCommand,
  void,
  string
>(client, {
  pattern: '/{locationId}/change-address',
  permissionId: locationCommandPermissions.CHANGE_ADDRESS
});
